import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_5: FaireProductEntity = {
  token: "atc_updated_moma_5",
  type: "product",
  name: "Colorful Glass Teapot & Cup Set",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a171be6efc7da6079f4312910ec5f37ed8c43537861694b34c5495db50c1950f.webp",
  priceDollars: 48,
  msrpDollars: 58,
  description: "Modern glass tea set with infuser.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
